import { Component, ViewChild } from '@angular/core';
import { IKontakt, ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-kontakti',
  templateUrl: './kontakti.component.html',
  styleUrls: ['./kontakti.component.scss']
})
export class KontaktiComponent {
  @ViewChild('kontaktiGrid', { static: false }) kontaktiGrid: any;

  gridData: IKontakt[] = [];
  loading = false;
  loadPanelPosition = { of: '#kontaktiGrid' };

  constructor(private apiClient: ApiClientService) {}

  ngOnInit() {
    this.loadKontakti();
  }

  async loadKontakti() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.kontaktAll();
    } catch (error) {
      console.error('Error loading kontakti:', error);
    } finally {
      this.loading = false;
    }
  }

  onRefreshClick() {
    this.loadKontakti();
  }
}
